import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useStore } from "./StoreShell";
import { StoreHeader } from "../../components/market/StoreHeader";
import { OrderItems } from "./OrderPage";
import { mk, ORDER_LABELS } from "../../lib/marketApi";

export default function MyOrders() {
  const { slug, store, buyer, setAuthOpen } = useStore();
  const [orders, setOrders] = useState(null);
  useEffect(() => {
    if (!buyer) {
      setAuthOpen(true);
      return;
    }
    mk(`/s/${slug}/buyer/orders`, { token: buyer.token }).then(setOrders).catch(() => setOrders([]));
  }, [buyer, slug, setAuthOpen]);

  return (
    <>
      <StoreHeader />
      <main className="mx-auto max-w-2xl px-4 py-8">
        <h1 className="text-2xl font-bold">Mis pedidos</h1>
        {!buyer && <p className="mt-6 text-sm opacity-60">Inicia sesión para ver tus pedidos.</p>}
        {orders && !orders.length && (
          <p className="mt-6 text-sm opacity-60" data-testid="my-orders-empty">
            Aún no tienes pedidos. <Link to={`/m/${slug}`} className="underline">Ver productos</Link>
          </p>
        )}
        <div className="mt-5 space-y-4">
          {(orders || []).map((o) => (
            <div key={o.id} className="p-5" style={{ background: "var(--mk-surface)", borderRadius: "var(--mk-radius)" }} data-testid={`my-order-${o.id}`}>
              <div className="mb-3 flex items-center justify-between">
                <p className="font-semibold">Pedido #{o.number}</p>
                <span className="rounded-full px-3 py-1 text-xs font-semibold text-white" style={{ background: o.status === "cancelled" ? "#94a3b8" : "var(--mk-primary)", color: o.status === "cancelled" ? "#fff" : "var(--mk-on-primary)" }}>
                  {ORDER_LABELS[o.status]}
                </span>
              </div>
              <OrderItems o={o} cur={store.currency} />
              <p className="mt-2 text-xs opacity-50">{new Date(o.created_at).toLocaleString("es-MX")} · {o.method === "pickup" ? "Recoger en tienda" : "Envío a domicilio"}</p>
            </div>
          ))}
        </div>
      </main>
    </>
  );
}
